<template>
    <div class="d-flex align-items-center min-vh-100">
        <CContainer fluid>
            <CRow class="justify-content-center">
                <CCol md="4">
                    <CCard class="mx-4 mb-0">
                        <CCardBody class="p-4">
                            <CForm @keyup.enter="validator();reset_password()" v-show="reset_password_form">
                                <h2>تنظیم مجدد رمز عبور</h2>
                                <p class="text-muted"></p>
                                <CInput v-model="form.username.val" :description="form.username.inv" label="شماره موبایل" dir="ltr" />
                                <CRow>
                                    <CCol col="6" class="text-left">
                                        <CButton @click="validator(2);reset_password()" color="primary" block>ارسال</CButton>
                                    </CCol>
                                    <CCol col="6" class="text-right">
                                        <CButton @click="redirect_to('/signin')" color="link" class="px-0">ورود</CButton>
                                    </CCol>
                                </CRow>
                            </CForm>
                            <CForm @keyup.enter="validator();verify()" v-show="verification_form">
                                <h2>تنظیم مجدد رمز عبور</h2>
                                <p class="text-muted"></p>
                                <CInput v-model="form.verification_code.val" :description="form.verification_code.inv" dir="ltr" label="کد تایید" />
                                <CInput v-model="form.password.val" :description="form.password.inv" label="رمز عبور" type="password" dir="ltr" />
                                <CInput v-model="form.repeat_password.val" :description="form.repeat_password.inv" label="تکرار رمز عبور" type="password" dir="ltr" />
                                <CRow>
                                    <CCol col="6" class="text-left">
                                        <CButton @click="validator();verify()" color="primary" block>ارسال</CButton>
                                    </CCol>
                                </CRow>
                            </CForm>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
    </div>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data() {
        return {
            form: {
                username: {val: '', inv: '', v: {req: true, max: 64, spec: 'mobile'}},
                password: {val: '', inv: '', v: {req: true, max: 64, spec: 'password'}},
                repeat_password: {val: '', inv: '', v: {req: true, max: 64, spec: 'repeat_password'}},
                verification_code: {val: '', inv: '', v: {req: true, max: 16}},
            },
            disable: false,
            reset_password_form: true,
            verification_form: false,
        }
    },
    methods: {
        reset_password() {
            if(this.disable == false){
                const data = new FormData();
                data.set('username', this.form.username.val);
                this.axios.post('reset_password', data)
                    .then(res => {
                        if (res.data.state == 'send_verification_code') {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'کد تایید ارسال شد.'
                            });
                            this.reset_password_form = false;
                            this.verification_form = true;
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    });
            }
        },
        verify() {
            if(this.disable == false){
                const data = new FormData();
                data.set('username', this.form.username.val);
                data.set('password', this.form.password.val);
                data.set('verification_code', this.form.verification_code.val);
                this.axios.post('reset_password', data)
                    .then(res => {
                        if (res.state == 'check_verification_code') {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'کد تایید معتبر نیست.'
                            });
                        } else {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'تنظیم مجدد رمز عبور با موفقیت انجام شد.'
                            });
                            if(this.$store.state.socket != 0){
                                try{
                                    this.$store.commit('socket_close');
                                } catch(err){}
                            }
                            localStorage.clear();
                            this.$store.commit('reset');
                            let d = new Date();
                            d.setMinutes(d.getMinutes() + 120);
                            this.$store.commit('set_expires', d);
                            this.$store.commit('set_token', `Bearer ${res.data.token}`);
                            this.$store.commit('set_user_id', res.data.user_info.id);
                            this.$store.commit('set_u_id', res.data.user_info.id);
                            this.$store.commit('set_perms', res.data.user_info.user_perm_array);
                            this.$store.commit('set_verif', res.data.user_info.is_verified);
                            if(this.$store.state.verif == true){
                                this.$router.push('/dashboard');
                            } else {
                                this.$router.push(`/user/${res.data.user_info.id}/edit`);
                            }
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    });
            }
        },
        redirect_to(route) {
            this.$router.push(route);
        },
    }
}
</script>
